import React, {Component} from 'react'
import { LoadingIcon } from '../../Svg/Index.js'

class Loader extends Component {

    render() {
        return (
            <div className={`c-loader ${this.props.withClass}`}>
                <div className="o-spacer"></div>
                <div className="c-loader__inner">
                    <LoadingIcon />
                </div>
            </div>
        )
    }
}

export default Loader